import config from 'styles/config'
import appConfig from './../config'
import Color from 'color'

export const getThemedColor = (theme, id) => {
  const themeColors = config.colors[`${theme}Theme`]

  if (themeColors && themeColors[id]) {
    return themeColors[id]
  }

  return config.colors[id]
}

export const getMainColor = theme => Color(theme.main_color)

export const regularFont = () => {
  return {
    fontFamily: "Roboto, sans-serif",
    fontWeight: 400
  }
}

export const regularFontItalic = () => {
  return {
    fontFamily: "Roboto, sans-serif",
    fontWeight: 400,
    fontStyle: "italic"
  }
}

export const boldFont = () => {
  return {
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500
  }
}

export const titleFont = () => {
  return {
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 400
  }
}

export const titleFontSemiBold = () => {
  return {
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 500
  }
}

export const iconFont = () => {
  return {
    fontFamily: "'Font Awesome 5 Pro'",
    fontWeight: 300,
  }
}

const fontBaseSize = () => {
  return 1 / (appConfig.get('FONT_BASE_SIZE') || 16)
}

const computeSize = (size, unit) => {
  if (appConfig.get('FONT_CSS_UNIT') === 'px') return `${size}px`
  else return `${fontBaseSize() * size}rem`
}

export const fontSize = (size) => {
  return { fontSize: computeSize(size) }
}

export const lineHeight = (height) => {
  return { lineHeight: computeSize(height) }
}

export const textSize = (size, height) => {
  return {
    ...fontSize(size),
    ...lineHeight(height)
  }
}

export const color = (id, theme) => {
  return { color: getThemedColor(theme, id) }
}

export const backgroundColor = (id, theme) => {
  return { backgroundColor: getThemedColor(theme, id) }
}

export const borderColor = (id, theme) => {
  return { borderColor: getThemedColor(theme, id) }
}

export const zIndex = id => {
  return { zIndex: config.zIndices[id] }
}

export const triangle = (size, background, props = {}) => {
  return {
    '&:before': {
  		position: 'absolute',
  		border: 'solid transparent',
  		content: '" "',
  		height: 0,
  		width: 0,
  		borderColor: 'rgba(0, 0, 0, 0)',
  		borderBottomColor: config.colors[background],
  		borderWidth: size / 2,
      ...props,
  	}
  }
}
